import { __decorate, __metadata } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, NgZone, Directive, Input } from '@angular/core';
import { asArray } from '@ng-doc/core/helpers/as-array';
import { toElement } from '@ng-doc/ui-kit/helpers';
import { ngDocZoneDetach } from '@ng-doc/ui-kit/observables';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { merge, fromEvent } from 'rxjs';
let NgDocEventSwitcherDirective = /*#__PURE__*/(() => {
  let NgDocEventSwitcherDirective = class NgDocEventSwitcherDirective {
    constructor(elementRef, ngZone) {
      this.elementRef = elementRef;
      this.ngZone = ngZone;
      this.switchTo = null;
      this.events = [];
    }
    ngOnInit() {
      merge(...asArray(this.events).map(eventName => fromEvent(this.elementRef.nativeElement, eventName))).pipe(ngDocZoneDetach(this.ngZone), untilDestroyed(this)).subscribe(event => {
        if (this.switchTo && !event.defaultPrevented && event.bubbles) {
          event.stopPropagation();
          this.makeEvent(event, toElement(this.switchTo));
        }
      });
    }
    makeEvent(from, target) {
      const eventConstructor = from.constructor;
      target.dispatchEvent(new eventConstructor(from.type, from));
    }
    static {
      this.ɵfac = function NgDocEventSwitcherDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocEventSwitcherDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgDocEventSwitcherDirective,
        selectors: [["", "ngDocEventSwitcher", ""]],
        inputs: {
          switchTo: [0, "ngDocEventSwitcher", "switchTo"],
          events: "events"
        },
        standalone: true
      });
    }
  };
  NgDocEventSwitcherDirective = __decorate([UntilDestroy(), __metadata("design:paramtypes", [ElementRef, NgZone])], NgDocEventSwitcherDirective);
  return NgDocEventSwitcherDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocEventSwitcherDirective };
